import { useLocation } from '@reach/router'
import { fireEvent } from '@/utils/activityLog'

interface ReturnValue {
  /** fireEventの`transitionPage`を発火する */
  readonly transitionPage: () => void
}

/**
 * @file
 * 画面描画時にActivity Log Eventを発火するカスタムフック
 *
 * @returns @see {@link ReturnValue} を参照
 */
export const useTransitionPage = (): ReturnValue => {
  const location = useLocation()
  const currentPath = location.pathname

  const transitionPage = () => {
    fireEvent({
      event: 'transitionPage',
      parameters: {
        current_path: currentPath,
      },
    })
  }

  return {
    transitionPage,
  }
}
